<template>
  <a-tabs>
    <a-tab-pane key="1" tab="按批次范围添加">
      <div class='mb10 s_flex_ali' v-if="$route.query.type!='detail'">
        <span class='mr15'>
          <a-button type="primary" @click="batchVisible=true">
            <PlusOutlined />
            添加活动范围
          </a-button>
        </span>
      </div>
      <div class="s_c999 mb10"><span class="s_c333">已添加范围列表：</span> （提示：必须添加至少一个范围，所选范围不能重复或重叠）</div>
      <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='list'
        :scroll="{ x: true}">
        <template v-slot:action="{ record }">
          <a-popconfirm title="确定要删除该活动么？" @confirm="del(record)" ok-text="删除" cancel-text="取消" placement="topRight"
            v-if="$route.query.type!='detail'">
            <a-button type="danger" size="small" href="javascript:;">删除</a-button>
          </a-popconfirm>
        </template>
      </a-table>
    </a-tab-pane>
    <a-tab-pane key="2">
      <template #tab>
        <a-tooltip placement="right" :auto-adjust-overflow="false">
          <template #title>
            <p>1.此功能需开通“智能防窜”应用才能生效
              2.可同时进行按批次添加和按出库单号添加进行二维码范围设置，自动会自动去除重复二维码</p>
          </template>
          按出库单号添加
          <InfoCircleOutlined />
        </a-tooltip>
      </template>
      <outboundOrder :activity_id="activity_id" />
    </a-tab-pane>

  </a-tabs>
  <div class="s_flex_center">
    <a-button @click="provide()" class="  m-t-20 m-r-20">上一步</a-button>
    <!-- <a-button type="primary" @click="next()" class="  m-t-20 ">保存</a-button> -->
    <a-button type="primary" @click="next()" class="  m-t-20 ">下一步</a-button>
  </div>
  <a-modal :keyboard="false" v-model:visible="batchVisible" centered :width='1000' :maskClosable="false" :footer="null">
    <selectScopeOfActivity :activity_id="activity_id" v-on:success="successBatch" />
  </a-modal>
</template>
<script>
  import {
    activitysTwoDel,
    activitysTwoDetail,
    activitysTwoUpdate,
  } from "@/api/guide";
  import { PlusOutlined, InfoCircleOutlined } from "@ant-design/icons-vue";
  import outboundOrder from "./outboundOrder";
  import { inject, onMounted, reactive, ref, toRefs } from "vue";
  import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
  const labelCol = { span: 4 };
  const wrapperCol = { span: 18 };
  let columns = [
    {
      title: "批次",
      dataIndex: "batch_sn",
      key: "batch_sn",
    },
    {
      title: "起始流水号",
      dataIndex: "small_serial_start",
      key: "small_serial_start",
    },
    {
      title: "结束流水号",
      key: "small_serial_end",
      dataIndex: "small_serial_end",
    },
    {
      title: "区间数量",
      dataIndex: "code_counts",
      key: "code_counts",
    },
    {
      title: "备注",
      dataIndex: "remarks",
      key: "remarks",
    },
    {
      title: "操作",
      key: "action",
      width: 150,
      slots: { customRender: "action" },
    },
  ];
  export default {
    components: { PlusOutlined, outboundOrder, InfoCircleOutlined },
    props: {
      activity_id: {
        type: Number,
        default: () => {
          return null;
        },
      },
    },
    setup(props, { emit }) {
      const state = reactive({
        batchVisible: false,
      });
      const listLoading = ref(true);
      const list = ref([]);
      // 获取详情
      const detail = async () => {
        listLoading.value = true;
        let result = await activitysTwoDetail(props.activity_id)
          .then((res) => res.data)
          .catch((error) => error);

        listLoading.value = false;
        if (iscode(result)) {
          list.value = result.data.data;
        }
      };
      const $router = inject("$router");
      // 下一步
      // const next = () => {
      //   $router.go(-1);
      // };
      const next = () => {
        console.log(111);
        emit("setpsTwoNext", 1);
      };
      const provide = () => {
        emit("setpsTwoProvide", 1);
      };
      // 删除
      const del = async (data) => {
        console.log(data);
        let result = await activitysTwoDel(data.id)
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result, true)) {
          detail();
        }
      };

      onMounted(() => {
        detail();
      });
      const successBatch = async (data) => {
        const hide = message.loading("正在加载中...", 0);
        let result = await activitysTwoUpdate(props.activity_id, data)
          .then((res) => res.data)
          .catch((error) => error);
        setTimeout(hide);
        if (iscode(result, true)) {
          detail();
          state.batchVisible = false;
        }
      };
      return {
        columns,
        listLoading,
        list,
        labelCol,
        wrapperCol,
        del,
        detail,
        next,
        provide,
        ...toRefs(state),
        successBatch
      };
    },
  };
</script>